import { render, staticRenderFns } from "./scorerecord.vue?vue&type=template&id=6795a56e&scoped=true"
import script from "./scorerecord.vue?vue&type=script&lang=js"
export * from "./scorerecord.vue?vue&type=script&lang=js"
import style0 from "./scorerecord.vue?vue&type=style&index=0&id=6795a56e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6795a56e",
  null
  
)

export default component.exports